export default {
    parts: ['fieldTitle', 'navContainer', 'navButton'],
    baseStyle: {
        fieldTitle: {
            textStyle: 'labelSmMd',
            mb: {base: 3}
        },
        navContainer: {
            position: 'absolute',
            top: '50%',
            display: {base: 'none', lg: 'flex'},
            transform: 'translateY(-50%)',
            zIndex: '1',
            width: '100%',
            justifyContent: 'space-between',
            pointerEvents: 'none'
        },
        navButton: {
            width: '32px',
            height: '32px',
            backgroundColor: 'white',
            blur: '10',
            pointerEvents: 'auto'
        }
    },

    // Keep direct access compatibility for existing usages like theme.components.WriteReview.fieldTitle
    fieldTitle: {
        textStyle: 'labelSmMd',
        mb: {base: 3}
    }
}
